import { action, computed, makeObservable, observable } from 'mobx';
import { CSSProperties } from 'react';
import { CatalogState } from './catalogState';

const ItemWidth = 240;
const GridGap = 16;

export class CarouselState {
  constructor(model: CatalogState) {
    makeObservable(this, {
      transformPosition: observable,
      itemWidth: observable,
      gridGap: observable,
      gridWidth: observable,
      windowWidth: observable,
      gridStyles: computed,
      isAtCarouselEnd: computed,
      updateGridWidth: action,
      setGridWidth: action,
      setWindowWidth: action,
      handleNext: action,
      handlePrev: action,
    });

    this.catalog = model;
  }

  readonly catalog: CatalogState;

  transformPosition: number = 0;
  itemWidth: number = ItemWidth;
  gridGap: number = GridGap;
  gridWidth: number = 0;
  windowWidth: number = 0;


  get gridStyles(): CSSProperties {
    return {
      transition: 'transform 0.15s',
      transform: `translateX(${this.transformPosition}px)`,
      width: `${this.gridWidth}px`
    }
  }

  get isAtCarouselEnd() {
    return this.gridWidth + this.transformPosition <= this.windowWidth - this.gridGap * 2;
  }

  updateGridWidth(numberOfEntities: number) {
    this.setGridWidth(numberOfEntities * this.itemWidth + (numberOfEntities - 1) * this.gridGap);
  }

  setGridWidth(width: number) {
    this.gridWidth = width;
  }

  setWindowWidth(width: number) {
    this.windowWidth = width;
  }

  handleNext = () => {
    if (this.catalog.syncStatus === 'fetchingMore') {
      return;
    }

    let position = this.transformPosition - this.itemWidth - this.gridGap;
    const willBeAtTheEnd = this.gridWidth + position <= this.windowWidth;

    if (willBeAtTheEnd) {

      if (!this.catalog.isEndOfList) {
        position = this.windowWidth - this.gridWidth - GridGap * 2;
        this.catalog.loadMore();
      } else {
        position = this.windowWidth - this.gridWidth - GridGap * 3;
      }

    }
    this.transformPosition = position;
  }

  handlePrev = () => {
    let position = this.transformPosition + this.itemWidth > 0 ? 0 : this.transformPosition + this.itemWidth + this.gridGap;

    if (this.isAtCarouselEnd) {
      position += 2 * this.gridGap;
    }
    this.transformPosition = position;
  }
}